export default __webpack_public_path__ + "static/media/ren_49.0fba596c.png";